import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import ImageView from './pages/ImageView';
import Export from './pages/Export';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/imageview" element={<ImageView />} />
        <Route path="/export" element={<Export />} />
      </Routes>
    </Router>
  );
}

export default App;
